import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../store/selector";
import { useTranslation } from "react-i18next";
import {
  FloatingIntroPanelStyle,
  FloatingIntroPanelHelloTextStyle,
  FloatingIntroPanelHowCanIHelpTextStyle
} from "./Styles";
import { ReactComponent as AIChatBotIcon } from "../../../assets/svg/teammate-ai.svg";

const FloatingIntroPanel = () => {
  const { t } = useTranslation();
  const user = useSelector(selectUser);

  return (
    <FloatingIntroPanelStyle>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          padding: "24px 20px",
          textAlign: "center"
        }}
      >
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "16px" }}>
          <AIChatBotIcon style={{ width: "48px", height: "48px" }} />
        </div>

        <div style={{ textAlign: "center" }}>
          <FloatingIntroPanelHelloTextStyle>
            {t("ai_chat_bot.intro_panel.hello_message", {
              firstName: user?.firstName
            })}
          </FloatingIntroPanelHelloTextStyle>
          <FloatingIntroPanelHowCanIHelpTextStyle>
            {t("ai_chat_bot.intro_panel.how_can_i_help")}
          </FloatingIntroPanelHowCanIHelpTextStyle>
        </div>
      </div>
    </FloatingIntroPanelStyle>
  );
};

export { FloatingIntroPanel };
